import { Box, List, Stack } from "@mantine/core";
import style from "./privacy.module.css";
import { useTranslation } from "react-i18next";
import { PrivacyMenu } from "./privacy-menu";

export const PrivacyPolicyPage = () => {
    const { t } = useTranslation(['privacy']);
    
    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <div className={style.contentWrapper}>
                    <Stack className={style.menuContent} spacing={"0.5rem"} mt={"10rem"}>
                        <PrivacyMenu />
                    </Stack>

                    <Box className={style.textContent} spacing={"0.5rem"} mt={"8rem"}>
                        <article>
                            <h1 className={style.header1}>{t("privacyPolicy.title")}</h1>

                            <p>{t("privacyPolicy.intro")}</p>

                            <br />
                            <h2 className={style.header2}>{t("privacyPolicy.section1.title")}</h2>
                            <p>{t("privacyPolicy.section1.intro")}</p>
                            <br />
                            <p>{t("privacyPolicy.section1.personalInfo")}</p>
                            <br />
                            <p>{t("privacyPolicy.section1.accountInfo")}</p>
                            <br />
                            <p>{t("privacyPolicy.section1.userContent")}</p>
                            <br />
                            <p>{t("privacyPolicy.section1.socialMedia")}</p>
                            <br />
                            <p>{t("privacyPolicy.section1.automaticInfo")}</p>
                            <br />
                            <p>{t("privacyPolicy.section1.logData")}</p>

                            <br />
                            <h2 className={style.header2}>{t("privacyPolicy.section2.title")}</h2>
                            <p>{t("privacyPolicy.section2.intro")}</p>
                            <List>
                                <List.Item>
                                    <p>{t("privacyPolicy.section2.purpose1")}</p>
                                </List.Item>

                                <List.Item>
                                    <p>{t("privacyPolicy.section2.purpose2")}</p>
                                </List.Item>

                                <List.Item>
                                    <p>{t("privacyPolicy.section2.purpose3")}</p>
                                </List.Item>

                                <List.Item>
                                    <p>{t("privacyPolicy.section2.purpose4")}</p>
                                </List.Item>

                                <List.Item>
                                    <p>{t("privacyPolicy.section2.purpose5")}</p>
                                </List.Item>

                                <List.Item>
                                    <p>{t("privacyPolicy.section2.purpose6")}</p>
                                </List.Item>
                            </List>
                            <br />

                            <p>{t("privacyPolicy.section2.aggregatedInfo")}</p>
                            <br />
                            <p>{t("privacyPolicy.section2.noTraining")}</p>
                            <br />

                            <h2 className={style.header2}>{t("privacyPolicy.section3.title")}</h2>
                            <p>{t("privacyPolicy.section3.intro")}</p>
                            <br />

                            <p>{t("privacyPolicy.section3.circumstances")}</p>
                            <br />

                            <p>{t("privacyPolicy.section3.vendors")}</p>
                            <br />

                            <p>{t("privacyPolicy.section3.businessTransfers")}</p>
                            <br />

                            <p>{t("privacyPolicy.section3.legalRequirements")}</p>
                            <br />

                            <p>{t("privacyPolicy.section3.affiliates")}</p>
                            <br />

                            <h2 className={style.header2}>{t("privacyPolicy.section4.title")}</h2>
                            <p>{t("privacyPolicy.section4.intro")}</p>
                            <br />

                            <p>{t("privacyPolicy.section4.rights")}</p>
                            <br />

                            <h2 className={style.header2}>{t("privacyPolicy.section5.title")}</h2>
                            <p>{t("privacyPolicy.section5.security")}</p>
                            <br />

                            <p>{t("privacyPolicy.section5.retention")}</p>
                            <br />

                            <p>{t("privacyPolicy.section5.anonymization")}</p>
                            <br />

                            <h2 className={style.header2}>{t("privacyPolicy.section6.title")}</h2>
                            <p>{t("privacyPolicy.section6.intro")}</p>
                            <br />

                            <p>{t("privacyPolicy.section6.legalBasis")}</p>
                            <br />

                            <p>{t("privacyPolicy.section6.details")}</p>
                            <br />

                            <h2 className={style.header2}>{t("privacyPolicy.section7.title")}</h2>
                            <p>{t("privacyPolicy.section7.content")}</p>
                            <br />

                            <h2 className={style.header2}>{t("privacyPolicy.section8.title")}</h2>
                            <p>{t("privacyPolicy.section8.content")}</p>
                            <br />

                            <h2 className={style.header2}>{t("privacyPolicy.section9.title")}</h2>
                            <p>{t("privacyPolicy.section9.content")}</p>
                            <br />
                        </article>
                    </Box>
                </div>
            </div>
        </div>
    );
};
